import { createContext, useContext, useState } from "react";
import {
  fetchClientAndToken,
  fetchClientsIds,
  fetchConfig,

} from "../services/tipddy-v2/clients";
import { baseURL as configuredMoodleURL } from "../services/apirest";

let LOCALHOST = "localhost";

// LOCAL PROTOTYPE: the remote theme registry (tipddy.cl) is unreachable from
// localhost (CORS), so remoteConfig.theme is undefined and the app crashes
// on `config.theme.colors.*`. This fallback keeps the app renderable in local
// dev without depending on that remote call.
const LOCAL_FALLBACK_THEME = {
  logo: "/logo.png",
  theme_logo_dark: "/logo.png",
  colors: {
    background_light: "#ffffff",
    background_dark: "#0f2844",
    background_body_light: "#ffffff",
    background_body_dark: "#0f2844",
    text_navbar_light: "#333333",
    text_navbar_dark: "#ffffff",
    background_banner_button_light: "#fdbf00",
    background_banner_button_dark: "#fdbf00",
    button_light: "#fdbf00",
    button_dark: "#fdbf00",
    text_button_light: "#333333",
    text_button_dark: "#333333",
    primary_light: "#1a4275",
    primary_dark: "#1a4275",
    secondary_light: "#12284b",
    secondary_dark: "#12284b",
    tertiary_light: "#0f233d",
    tertiary_dark: "#0f233d",
    background_pendiente_light: "#fdbf00",
    background_pendiente_dark: "#fdbf00",
    background_completado_light: "#5cb85c",
    background_completado_dark: "#5cb85c",
    background_tooltip_light: "#fdbf00",
    background_tooltip_dark: "#fdbf00",
    background_header_login: "#0f233d",
    background_body_login: "#0f233d",
    text_login_light: "#333333",
    text_login_dark: "#ffffff",
    background_banner_light: "#0f2844",
    background_banner_dark: "#0f2844",
  },
};

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  let actions = {};

  actions.getConfig = async function () {
    /* let domain = window.location.host;
    let token = await wordpresstoken();
    let clients = await fetchClientsIds({ token });

    let client = actions.getClientId({ clients, domain });
    console.log(client) */
    /*
     */
    let remoteConfig = {};
    let baseMoodleURL;
    try {
      const response = await fetchClientAndToken(297539);
      remoteConfig = response?.config || {};
    } catch (e) {
      console.warn("Client registry unavailable:", e);
    }

    baseMoodleURL = configuredMoodleURL;

    const theme = remoteConfig.config?.theme || LOCAL_FALLBACK_THEME;
    const config = {
      opciones: [],
      ...remoteConfig,
      theme,
      baseURL: baseMoodleURL,
    };

    document.title = config.titulo_interfaz || "Campus virtual";

    setConfig({ ...config });
    return config;
  };

  actions.verifyConfig = async function () {};

  actions.getClientId = ({ clients, domain }) => {
    console.log(clients);
    if (domain.includes(LOCALHOST)) {
      let host = domain.split(":")[0];
      let localhostClient = clients.find((c) =>
        c.baseInterfazURL?.includes(host)
      );
      /* return localhostClient; */

      return {
        ID: 26793,
        baseMoodleURL: 'https://e-aula.academia-tecnigen.cl',
        baseInterfazURL: 'https://participante.academia-tecnigen.cl/'
      }
    }
    
    let isValidClient = clients.find((c) =>
      c.baseInterfazURL?.includes(domain)
    ); 

    if (isValidClient) {
      return isValidClient;
    }
  };

  let value = {
    config,
    getConfig: actions.getConfig,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
